import { __decorate, __param } from 'tslib';
import { InjectionToken, ElementRef, Inject, ChangeDetectorRef, Input, HostBinding, HostListener, Component, ChangeDetectionStrategy, forwardRef, NgModule } from '@angular/core';
import { AbstractTuiInteractive, watch, pressedObservable, isNativeFocused, TuiFocusVisibleService, TuiHoveredService, TuiDestroyService, TUI_TAKE_ONLY_TRUSTED_EVENTS, tuiDefaultProp, TUI_FOCUSABLE_ITEM_ACCESSOR } from '@taiga-ui/cdk';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TuiLoaderModule } from '@taiga-ui/core/components/loader';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';
import { TuiWrapperModule } from '@taiga-ui/core/directives/wrapper';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core/directives/wrapper';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc4 from '@taiga-ui/core/components/svg';
import * as ɵngcc5 from '@taiga-ui/core/components/loader';
import * as ɵngcc6 from '@taiga-ui/cdk';
import * as ɵngcc7 from 'rxjs';

const _c0 = ["tuiButton", ""];
function TuiButtonComponent_span_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 6);
} if (rf & 2) {
    const icon_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("src", icon_r4);
} }
function TuiButtonComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtemplate(1, TuiButtonComponent_span_2_ng_template_1_Template, 1, 1, "ng-template");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("content", ctx_r0.icon);
} }
function TuiButtonComponent_span_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 6);
} if (rf & 2) {
    const icon_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("src", icon_r6);
} }
function TuiButtonComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtemplate(1, TuiButtonComponent_span_4_ng_template_1_Template, 1, 1, "ng-template");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("content", ctx_r1.iconRight);
} }
function TuiButtonComponent_tui_loader_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-loader", 8);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("size", ctx_r2.loaderSize)("inheritColor", true);
} }
const _c1 = ["*"];
const TUI_BUTTON_DEFAULT_OPTIONS = {
    size: 'l',
    shape: null,
    appearance: "primary" /* Primary */,
};
const TUI_BUTTON_OPTIONS = new InjectionToken('Default parameters for button component', {
    factory: () => TUI_BUTTON_DEFAULT_OPTIONS,
});
const tuiButtonOptionsProvider = (options) => ({
    provide: TUI_BUTTON_OPTIONS,
    useValue: Object.assign(Object.assign({}, TUI_BUTTON_DEFAULT_OPTIONS), options),
});

var TuiButtonComponent_1;
let TuiButtonComponent = TuiButtonComponent_1 = class TuiButtonComponent extends AbstractTuiInteractive {
    constructor(elementRef, focusVisible$, hoveredService, destroy$, changeDetectorRef, takeOnlyTrustedEvents, options) {
        super();
        this.elementRef = elementRef;
        this.takeOnlyTrustedEvents = takeOnlyTrustedEvents;
        this.options = options;
        this.appearance = this.options.appearance || '';
        this.disabled = false;
        this.icon = '';
        this.iconRight = '';
        this.shape = this.options.shape;
        this.showLoader = false;
        this.size = this.options.size;
        hoveredService
            .createHovered$(elementRef.nativeElement)
            .pipe(watch(changeDetectorRef), takeUntil(destroy$))
            .subscribe(hovered => {
            this.updateHovered(hovered);
        });
        pressedObservable(elementRef.nativeElement, {
            onlyTrusted: this.takeOnlyTrustedEvents,
        })
            .pipe(watch(changeDetectorRef), takeUntil(destroy$))
            .subscribe(pressed => {
            this.updatePressed(pressed);
        });
        focusVisible$.subscribe(focusVisible => {
            this.updateFocusVisible(focusVisible);
        });
    }
    get nativeFocusableElement() {
        return this.nativeDisabled ? null : this.elementRef.nativeElement;
    }
    get focused() {
        return !this.showLoader && isNativeFocused(this.elementRef.nativeElement);
    }
    get loaderSize() {
        return this.size === 'l' || this.size === 'xl' ? 'm' : 's';
    }
    get nativeDisabled() {
        return this.computedDisabled || this.showLoader ? '' : null;
    }
    get tabIndex() {
        return this.focusable ? 0 : -1;
    }
    onFocused(focused) {
        this.updateFocused(focused);
    }
};
TuiButtonComponent.ɵfac = function TuiButtonComponent_Factory(t) { return new (t || TuiButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TuiFocusVisibleService), ɵngcc0.ɵɵdirectiveInject(TuiHoveredService), ɵngcc0.ɵɵdirectiveInject(TuiDestroyService), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TUI_TAKE_ONLY_TRUSTED_EVENTS), ɵngcc0.ɵɵdirectiveInject(TUI_BUTTON_OPTIONS)); };
TuiButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiButtonComponent, selectors: [["button", "tuiButton", ""], ["button", "tuiIconButton", ""], ["a", "tuiButton", ""], ["a", "tuiIconButton", ""]], hostVars: 7, hostBindings: function TuiButtonComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function TuiButtonComponent_focusin_HostBindingHandler() { return ctx.onFocused(true); })("focusout", function TuiButtonComponent_focusout_HostBindingHandler() { return ctx.onFocused(false); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("tabIndex", ctx.tabIndex);
        ɵngcc0.ɵɵattribute("data-appearance", ctx.appearance)("data-shape", ctx.shape)("data-size", ctx.size)("disabled", ctx.nativeDisabled);
        ɵngcc0.ɵɵclassProp("_loading", ctx.showLoader);
    } }, inputs: { appearance: "appearance", disabled: "disabled", icon: "icon", iconRight: "iconRight", shape: "shape", showLoader: "showLoader", size: "size" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiButtonComponent_1)
            },
            TuiDestroyService,
            TuiFocusVisibleService,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c0, ngContentSelectors: _c1, decls: 6, vars: 8, consts: [[1, "t-wrapper", 3, "appearance", "hovered", "pressed", "disabled", "focused"], [1, "t-content"], ["polymorpheus-outlet", "", "class", "t-left", 3, "content", 4, "ngIf"], ["polymorpheus-outlet", "", "class", "t-right", 3, "content", 4, "ngIf"], ["class", "t-loader", 3, "size", "inheritColor", 4, "ngIf"], ["polymorpheus-outlet", "", 1, "t-left", 3, "content"], [1, "t-icon", 3, "src"], ["polymorpheus-outlet", "", 1, "t-right", 3, "content"], [1, "t-loader", 3, "size", "inheritColor"]], template: function TuiButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "tui-wrapper", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, TuiButtonComponent_span_2_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵtemplate(4, TuiButtonComponent_span_4_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, TuiButtonComponent_tui_loader_5_Template, 1, 2, "tui-loader", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("appearance", ctx.appearance)("hovered", ctx.computedHovered)("pressed", ctx.computedPressed)("disabled", ctx.computedDisabled)("focused", ctx.computedFocusVisible);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconRight);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLoader);
    } }, directives: [ɵngcc1.TuiWrapperDirective, ɵngcc2.NgIf, ɵngcc3.PolymorpheusOutletComponent, ɵngcc4.TuiSvgComponent, ɵngcc5.TuiLoaderComponent], styles: ["[_nghost-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;font:var(--tui-font-text-s);color:var(--tui-text-01);position:relative;display:inline-block;flex-shrink:0;vertical-align:top;border-radius:var(--tui-radius-m);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-decoration:none;font-weight:700;outline:0}[disabled][_nghost-%COMP%]{pointer-events:none}[tuiIconButton][_nghost-%COMP%]   .t-left[_ngcontent-%COMP%], [tuiIconButton][_nghost-%COMP%]   .t-right[_ngcontent-%COMP%]{margin:0}[data-shape=rounded][_nghost-%COMP%]{border-radius:6.25rem}[data-size=xs][_nghost-%COMP%]{height:var(--tui-height-xs);font-weight:400}[data-size=xs][data-shape=square][_nghost-%COMP%], [data-size=xs][tuiIconButton][_nghost-%COMP%]{height:var(--tui-height-xs);width:var(--tui-height-xs)}[data-size='s'][_nghost-%COMP%]{height:var(--tui-height-s);font-weight:400}[data-size='s'][data-shape=square][_nghost-%COMP%], [data-size='s'][tuiIconButton][_nghost-%COMP%]{height:var(--tui-height-s);width:var(--tui-height-s)}[data-size='m'][_nghost-%COMP%]{height:var(--tui-height-m);font-size:.9375rem}[data-size='m'][data-shape=square][_nghost-%COMP%], [data-size='m'][tuiIconButton][_nghost-%COMP%]{height:var(--tui-height-m);width:var(--tui-height-m)}[data-size='l'][_nghost-%COMP%]{height:var(--tui-height-l);font-size:.9375rem}[data-size='l'][data-shape=square][_nghost-%COMP%], [data-size='l'][tuiIconButton][_nghost-%COMP%]{height:var(--tui-height-l);width:var(--tui-height-l)}[data-size=xl][_nghost-%COMP%]{height:3.75rem;font-size:.9375rem}[data-size=xl][data-shape=square][_nghost-%COMP%], [data-size=xl][tuiIconButton][_nghost-%COMP%]{height:3.75rem;width:3.75rem}.t-loader[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;cursor:default}.t-left[_ngcontent-%COMP%]{margin:0 .5rem 0 -.25rem}.t-right[_ngcontent-%COMP%]{margin:0 -.5rem 0 .25rem}.t-icon[_ngcontent-%COMP%]{display:block}[data-size='s'][_nghost-%COMP%]   .t-icon[_ngcontent-%COMP%], [data-size=xs][_nghost-%COMP%]   .t-icon[_ngcontent-%COMP%]{width:1rem;height:1rem}[tuiIconButton][_nghost-%COMP%]   .t-icon[_ngcontent-%COMP%], [tuiIconButton][_nghost-%COMP%]   .t-left[_ngcontent-%COMP%], [tuiIconButton][_nghost-%COMP%]   .t-right[_ngcontent-%COMP%]{display:flex;width:100%;height:100%;align-items:center;justify-content:center}.t-wrapper[_ngcontent-%COMP%]{position:relative;z-index:0;box-sizing:border-box;cursor:pointer}[data-size=xs][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{padding:0 .5rem}[data-size='s'][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{padding:0 .75rem}[data-size='m'][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{padding:0 1.5rem}[data-size='l'][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{padding:0 2.25rem}[data-size=xl][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{padding:0 2.5rem}[data-shape=square][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%], [tuiIconButton][_nghost-%COMP%]   .t-wrapper[_ngcontent-%COMP%]{padding:0}.t-content[_ngcontent-%COMP%]{display:flex;height:100%;align-items:center;justify-content:center;text-align:center}._loading[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{opacity:0}"], changeDetection: 0 });
TuiButtonComponent.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: TuiFocusVisibleService, decorators: [{ type: Inject, args: [TuiFocusVisibleService,] }] },
    { type: TuiHoveredService, decorators: [{ type: Inject, args: [TuiHoveredService,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TuiDestroyService,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_TAKE_ONLY_TRUSTED_EVENTS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_BUTTON_OPTIONS,] }] }
];
__decorate([
    Input(),
    HostBinding('attr.data-appearance'),
    tuiDefaultProp()
], TuiButtonComponent.prototype, "appearance", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiButtonComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiButtonComponent.prototype, "icon", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiButtonComponent.prototype, "iconRight", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-shape'),
    tuiDefaultProp()
], TuiButtonComponent.prototype, "shape", void 0);
__decorate([
    Input(),
    HostBinding('class._loading'),
    tuiDefaultProp()
], TuiButtonComponent.prototype, "showLoader", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-size'),
    tuiDefaultProp()
], TuiButtonComponent.prototype, "size", void 0);
__decorate([
    HostBinding('attr.disabled')
], TuiButtonComponent.prototype, "nativeDisabled", null);
__decorate([
    HostBinding('tabIndex')
], TuiButtonComponent.prototype, "tabIndex", null);
__decorate([
    HostListener('focusin', ['true']),
    HostListener('focusout', ['false'])
], TuiButtonComponent.prototype, "onFocused", null);
TuiButtonComponent = TuiButtonComponent_1 = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(TuiFocusVisibleService)),
    __param(2, Inject(TuiHoveredService)),
    __param(3, Inject(TuiDestroyService)),
    __param(4, Inject(ChangeDetectorRef)),
    __param(5, Inject(TUI_TAKE_ONLY_TRUSTED_EVENTS)),
    __param(6, Inject(TUI_BUTTON_OPTIONS))
], TuiButtonComponent);

let TuiButtonModule = class TuiButtonModule {
};
TuiButtonModule.ɵfac = function TuiButtonModule_Factory(t) { return new (t || TuiButtonModule)(); };
TuiButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiButtonModule });
TuiButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PolymorpheusModule,
            TuiWrapperModule,
            TuiSvgModule,
            TuiLoaderModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiButtonComponent, [{
        type: Component,
        args: [{
                selector: 'button[tuiButton], button[tuiIconButton], a[tuiButton], a[tuiIconButton]',
                template: "<tui-wrapper\n    class=\"t-wrapper\"\n    [appearance]=\"appearance\"\n    [hovered]=\"computedHovered\"\n    [pressed]=\"computedPressed\"\n    [disabled]=\"computedDisabled\"\n    [focused]=\"computedFocusVisible\"\n>\n    <span class=\"t-content\">\n        <span\n            *ngIf=\"icon\"\n            polymorpheus-outlet\n            class=\"t-left\"\n            [content]=\"icon\"\n        >\n            <ng-template let-icon>\n                <tui-svg\n                    class=\"t-icon\"\n                    [src]=\"icon\"\n                ></tui-svg>\n            </ng-template>\n        </span>\n        <ng-content></ng-content>\n        <span\n            *ngIf=\"iconRight\"\n            polymorpheus-outlet\n            class=\"t-right\"\n            [content]=\"iconRight\"\n        >\n            <ng-template let-icon>\n                <tui-svg\n                    class=\"t-icon\"\n                    [src]=\"icon\"\n                ></tui-svg>\n            </ng-template>\n        </span>\n    </span>\n    <tui-loader\n        *ngIf=\"showLoader\"\n        class=\"t-loader\"\n        [size]=\"loaderSize\"\n        [inheritColor]=\"true\"\n    ></tui-loader>\n</tui-wrapper>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiButtonComponent_1)
                    },
                    TuiDestroyService,
                    TuiFocusVisibleService,
                ],
                styles: [":host{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:0 0;font-size:inherit;line-height:inherit;font:var(--tui-font-text-s);color:var(--tui-text-01);position:relative;display:inline-block;flex-shrink:0;vertical-align:top;border-radius:var(--tui-radius-m);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-decoration:none;font-weight:700;outline:0}:host[disabled]{pointer-events:none}:host[tuiIconButton] .t-left,:host[tuiIconButton] .t-right{margin:0}:host[data-shape=rounded]{border-radius:6.25rem}:host[data-size=xs]{height:var(--tui-height-xs);font-weight:400}:host[data-size=xs][data-shape=square],:host[data-size=xs][tuiIconButton]{height:var(--tui-height-xs);width:var(--tui-height-xs)}:host[data-size='s']{height:var(--tui-height-s);font-weight:400}:host[data-size='s'][data-shape=square],:host[data-size='s'][tuiIconButton]{height:var(--tui-height-s);width:var(--tui-height-s)}:host[data-size='m']{height:var(--tui-height-m);font-size:.9375rem}:host[data-size='m'][data-shape=square],:host[data-size='m'][tuiIconButton]{height:var(--tui-height-m);width:var(--tui-height-m)}:host[data-size='l']{height:var(--tui-height-l);font-size:.9375rem}:host[data-size='l'][data-shape=square],:host[data-size='l'][tuiIconButton]{height:var(--tui-height-l);width:var(--tui-height-l)}:host[data-size=xl]{height:3.75rem;font-size:.9375rem}:host[data-size=xl][data-shape=square],:host[data-size=xl][tuiIconButton]{height:3.75rem;width:3.75rem}.t-loader{position:absolute;top:0;left:0;width:100%;height:100%;cursor:default}.t-left{margin:0 .5rem 0 -.25rem}.t-right{margin:0 -.5rem 0 .25rem}.t-icon{display:block}:host[data-size='s'] .t-icon,:host[data-size=xs] .t-icon{width:1rem;height:1rem}:host[tuiIconButton] .t-icon,:host[tuiIconButton] .t-left,:host[tuiIconButton] .t-right{display:flex;width:100%;height:100%;align-items:center;justify-content:center}.t-wrapper{position:relative;z-index:0;box-sizing:border-box;cursor:pointer}:host[data-size=xs] .t-wrapper{padding:0 .5rem}:host[data-size='s'] .t-wrapper{padding:0 .75rem}:host[data-size='m'] .t-wrapper{padding:0 1.5rem}:host[data-size='l'] .t-wrapper{padding:0 2.25rem}:host[data-size=xl] .t-wrapper{padding:0 2.5rem}:host[data-shape=square] .t-wrapper,:host[tuiIconButton] .t-wrapper{padding:0}.t-content{display:flex;height:100%;align-items:center;justify-content:center;text-align:center}:host._loading .t-content{opacity:0}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc6.TuiFocusVisibleService, decorators: [{
                type: Inject,
                args: [TuiFocusVisibleService]
            }] }, { type: ɵngcc6.TuiHoveredService, decorators: [{
                type: Inject,
                args: [TuiHoveredService]
            }] }, { type: ɵngcc7.Observable, decorators: [{
                type: Inject,
                args: [TuiDestroyService]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_TAKE_ONLY_TRUSTED_EVENTS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_BUTTON_OPTIONS]
            }] }]; }, { appearance: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-appearance']
        }], disabled: [{
            type: Input
        }], icon: [{
            type: Input
        }], iconRight: [{
            type: Input
        }], shape: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-shape']
        }], showLoader: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class._loading']
        }], size: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-size']
        }], nativeDisabled: [{
            type: HostBinding,
            args: ['attr.disabled']
        }], tabIndex: [{
            type: HostBinding,
            args: ['tabIndex']
        }], onFocused: [{
            type: HostListener,
            args: ['focusin', ['true']]
        }, {
            type: HostListener,
            args: ['focusout', ['false']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PolymorpheusModule,
                    TuiWrapperModule,
                    TuiSvgModule,
                    TuiLoaderModule,
                ],
                declarations: [TuiButtonComponent],
                exports: [TuiButtonComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiButtonModule, { declarations: function () { return [TuiButtonComponent]; }, imports: function () { return [CommonModule,
        PolymorpheusModule,
        TuiWrapperModule,
        TuiSvgModule,
        TuiLoaderModule]; }, exports: function () { return [TuiButtonComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_BUTTON_DEFAULT_OPTIONS, TUI_BUTTON_OPTIONS, TuiButtonComponent, TuiButtonModule, tuiButtonOptionsProvider };

